import {
    Alert,
    Box,
    Button,
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
    Typography,
} from "@mui/material";
import React from "react";
import CronExpressionBuilder from "../../components/CronExpressionBuilder";
import TaskSchedulerPayloadFields from "./TaskSchedulerPayloadFields";
import { TASK_SCHEDULER_CRON_PRESETS, TASK_SCHEDULER_TYPES } from "./taskSchedulerConstants";

export default function TaskTabScheduler({
    cron,
    onCronChange,
    type,
    onTypeChange,
    enabled,
    onEnabledChange,
    memo,
    onMemoChange,
    payload,
    onPayloadChange,
    onSubmit,
    onCancel,
    isEdit,
    onDelete,
}) {
    return (
        <form onSubmit={onSubmit}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, maxWidth: 640 }}>
                <Alert severity="info" sx={{ alignItems: "flex-start" }}>
                    Quartz jobs run only when{" "}
                    <Typography component="span" variant="body2" sx={{ fontFamily: "monospace" }}>
                        app.scheduler.enableTaskScheduler=true
                    </Typography>{" "}
                    on the server. Rows can still be edited here when it is off.
                </Alert>

                <FormControlLabel
                    control={<Switch checked={enabled} onChange={(e) => onEnabledChange(e.target.checked)} />}
                    label="Enabled"
                />

                <CronExpressionBuilder
                    value={cron}
                    onChange={onCronChange}
                    presets={TASK_SCHEDULER_CRON_PRESETS}
                />

                <FormControl fullWidth size="small">
                    <InputLabel id="task-scheduler-type-label">Task type</InputLabel>
                    <Select
                        labelId="task-scheduler-type-label"
                        label="Task type"
                        value={type}
                        onChange={(e) => onTypeChange(e.target.value)}
                    >
                        {TASK_SCHEDULER_TYPES.map((t) => (
                            <MenuItem key={t.value} value={t.value}>
                                {t.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <TaskSchedulerPayloadFields
                    type={type}
                    payload={payload}
                    onPayloadChange={onPayloadChange}
                />

                <TextField
                    label="Memo"
                    value={memo}
                    onChange={(e) => onMemoChange(e.target.value)}
                    fullWidth
                    size="small"
                    multiline
                    minRows={2}
                    placeholder="Optional admin notes"
                />

                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", pt: 1 }}>
                    <Button type="submit" variant="contained">
                        {isEdit ? "Save" : "Create"}
                    </Button>
                    <Button type="button" variant="outlined" onClick={onCancel}>
                        Cancel
                    </Button>
                    {isEdit && onDelete ? (
                        <Button type="button" color="error" variant="outlined" onClick={onDelete} sx={{ ml: "auto" }}>
                            Delete
                        </Button>
                    ) : null}
                </Box>
            </Box>
        </form>
    );
}
